import { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import { getSocket } from '@src/App';

import { _useDispatch, _useSelector } from '@src/state/hooks';
import { setStage } from '@src/state/slices/slice_app';
import { Stage } from '@src/state/slices/types';
import { useAccount } from 'wagmi';

import Button from '@src/components/styled/Button';
import TermsPanel from '@src/components/Lobby/TermsPanel';

import bg from '@src/asset/background/1975.png';
import { ConnectKitButton } from 'connectkit';

const Container = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  flex-grow: 1;

  font-size: 24px;
  text-align: center;

  align-items: center;
  justify-content: center;

  background-image: url(${bg});
  background-repeat: repeat;
`;

// styled info text with white color and background-color: #c0c0c0;
const InfoText = styled.div`
  color: #ffffff;
  background-color: #c0c0c0;
  padding: 10px;
  border-radius: 5px;
`;

// styled terms text with underline and blue color
const TermsText = styled.span`
  text-decoration: underline;
  color: #0000ff;
  background-color: #c0c0c0;
  cursor: pointer;
`;

export default function Login() {
  const dispatch = _useDispatch();
  const isConnectedToSocket = _useSelector((state) => state.app.isConnected);
  const socket = getSocket();
  const [showTermsPanel, setShowTermsPanel] = useState(false);

  // TODO: handle account changed, should disconnect user
  const { isConnected, address } = useAccount();
  console.log(
    'wallet connected',
    isConnected,
    'socket connected',
    isConnectedToSocket,
    'address',
    address,
  );

  useEffect(() => {
    if (isConnectedToSocket && isConnected) {
      dispatch(setStage({ stage: Stage.LOBBY, stageMeta: {} }));
    }
  }, [isConnectedToSocket, isConnected]);

  return (
    <Container>
      <ConnectKitButton.Custom>
        {({ show }) => (
          <Button
            onClick={() => {
              if (!isConnected) show?.();
              socket.connect();
            }}
          >
            Accept Terms And Connect
          </Button>
        )}
      </ConnectKitButton.Custom>
      <br />
      <InfoText>
        Access to ¡SANKO! is contingent on accepting the{' '}
        <TermsText onClick={() => setShowTermsPanel(true)}>
          Terms of Service
        </TermsText>
      </InfoText>
      {showTermsPanel && (
        <TermsPanel onPressBack={() => setShowTermsPanel(false)} />
      )}
    </Container>
  );
}
